<template>
  <v-app>
    <v-layout>
      <Drawer v-if="!isLoginPage" />
      <v-main>
        <router-view />
      </v-main>
    </v-layout>
  </v-app>
</template>

<script setup lang="ts">
import Drawer from "./components/Drawer.vue";
import { computed } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();

const isLoginPage = computed(() => route.name === "start");

</script>
